import Vue from 'vue'
import feature from 'vue-feature-toggle'
import store from '../store/index'


export const AccessRightRead = 'read'
export const AccessRightWrite = 'write'

export function hasAccessRightForCollection(collectionName, accessRight) {
  const scopes = store.getters.userScopes
  const companyId = store.getters.companyId
  
  if (!scopes) {
    return false
  }

  return (scopes?.includes(`companies.${companyId}.${collectionName}.${accessRight}`) ||
  scopes?.includes(`companies.${companyId}.${accessRight}`))
}

const features = ['people', 'warehouse', 'projects', 'jobs']

for (const featureName of features) {
  feature.visibility(featureName, 'read', (rule) => {
    return hasAccessRightForCollection(rule.data, AccessRightRead)
  })
  feature.visibility(featureName, 'write', (rule) => {
    return hasAccessRightForCollection(rule.data, AccessRightWrite)
  })
}

/**
 * Helper function for warehouse as it's using 3 data paths
 */
export function canAccessWarehouse() {
  return (
    hasAccessRightForCollection('categories', AccessRightRead) ||
    hasAccessRightForCollection('locations', AccessRightRead) ||
    hasAccessRightForCollection('materials', AccessRightRead)
  )
}

export function canAccessPeople() {
  return (
    hasAccessRightForCollection('workforce', AccessRightRead) ||
    hasAccessRightForCollection('contractors', AccessRightRead)
  )
}

Vue.component('feature', feature)

export default feature
